import axios from './axiosIntercepter';

const BASE_API_URL = "/";

// Generic POST
export const postRequest = async (endpoint, data, authToken) => {
  const fullUrl = `${BASE_API_URL}${endpoint}`;
  const config = authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : {};
  const response = await axios.post(fullUrl, data, config);
  return response.data;
};

// Generic PATCH
export const patchRequest = async (endpoint, data, authToken) => {
  const fullUrl = `${BASE_API_URL}${endpoint}`;
  const config = authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : {};
  const response = await axios.patch(fullUrl, data, config);
  return response.data;
};

// Generic DELETE
export const deleteRequest = async (endpoint, data, authToken) => {
  const fullUrl = `${BASE_API_URL}${endpoint}`;
  const config = authToken ? { headers: { Authorization: `Bearer ${authToken}` }, data } : { data };
  const response = await axios.delete(fullUrl, config);
  return response.data;
};


// Generic GET
export const getRequest = async (endpoint, authToken) => {
  const fullUrl = `${BASE_API_URL}${endpoint}`;
  const config = authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : {};
  const response = await axios.get(fullUrl, config);
  return response.data;
};

// Generic PUT
export const putRequest = async (endpoint, data, authToken) => {
  const fullUrl = `${BASE_API_URL}${endpoint}`;
  const config = authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : {};
  const response = await axios.put(fullUrl, data, config);
  return response.data;
};
